import React from 'react'
import styles from './Specifications.module.css'

const Specifications = () => {
    const specifications = {
        importantNote: "Cancellation NOT allowed for this product after 24 hrs of order booking.",
        general: {
            salesPackage: "1 Bed, Warranty Card",
            modelNumber: "PHQB2",
            modelSeriesName: "Carol",
            bedSize: "Queen",
            deliveryCondition: "Knock Down",
            primaryColor: "Brown",
            suitableFor: "Bedroom, Kids Room",
            storageIncluded: "No",
            withMattress: "No",
            recommendedMattressLength: "198.12 cm",
            recommendedMattressBreadth: "152.4 cm",
        },
        bodyAndDesignDetails: {
            bedMaterial: "Engineered Wood",
            bedMaterialSubtype: "Particle Board",
            headboardMaterial: "Engineered Wood",
            headboardMaterialSubtype: "Particle Board",
            upholsteryIncluded: "No",
            finishType: "Laminate",
            finishColor: "Amozonia Dark & White",
            headboardType: "Basic",
        },
        otherDetails: {
            style: "Contemporary & Modern",
            platform: "No",
            careInstructions: `DOs: 
(a) Use soft, dry towel for regular cleaning and dusting purposes. 
(b) Use coasters/mats/tablecloths when placing hot objects or cold bottles that may leave a mark on the surface. 
(c) In case of any spills, soak the liquid first and then wipe the surface with a dry cloth. 
(d) For cleaning the glass, use clean warm water or glass cleaner with a soft, lint-free cloth or a newspaper. 
(e) Before moving the furniture, always dismantle. 
DON'Ts: 
(a) Do not slide/drag/push the furniture. 
(b) Do not place the furniture under prolonged exposure to sunlight or near heat sources, like radiators, fireplaces, heaters or under damp conditions. 
(c) Do not clean metal parts or wooden panels with any chemical or cleaning agent. 
(d) Do not use an acid, alkaline, or abrasive cleaner on the glass surface. 
(e) Avoid any unnatural loading, dropping heavy materials, or using excessive force directly on the furniture. 
This may impact the structural integrity of the product.`,
        },
        dimensions: {
            width: "159.5 cm",
            height: "80 cm",
            depth: "203.5 cm",
            floorClearance: "1 cm",
            weight: "75 kg",
            recommendedMattressSize: "Length: 78 inch x Width: 60 inch",
        },
        warranty: {
            warrantySummary: "1 Year Warranty",
            serviceType: "In Case Any Query Customer Needs to Mail at Perfecthomes@Flipkart.com or Call on +918067987788",
            coveredInWarranty: "Manufacturing Defects",
            notCoveredInWarranty:
                "Damage Due to Inappropriate Handling If not Installed by Our Authorized Installing Partner Furniture Moved from One Location to Another without Dismantling Any Modifications or Alterations Made to the Product Post-purchase Normal Wear and Tear with Time Any Violation in Care Instructions",
            domesticWarranty: "1 Year",
        },
        installationAndDemo: {
            installationAndDemoDetails:
                "The installation and demo for this product are done free of cost as part of this purchase (valid only for Knock Down products). We will share the installation date at the time of order, according to which our service partner will visit your location.",
        },
    };


    return (
        <div className={styles.specifications}>
            <h3>Specifications</h3>
            <p><strong>Important Note:</strong> {specifications.importantNote}</p>

            <h4>General</h4>
            <ul>
                {Object.entries(specifications.general).map(([key, value]) => (
                    <li key={key}>
                        <strong>{key.replace(/([A-Z])/g, " $1")}: </strong>
                        {value}
                    </li>
                ))}
            </ul>

            <h4>Body And Design Details</h4>
            <ul>
                {Object.entries(specifications.bodyAndDesignDetails).map(([key, value]) => (
                    <li key={key}>
                        <strong>{key.replace(/([A-Z])/g, " $1")}: </strong>
                        {value}
                    </li>
                ))}
            </ul>

            <h4>Other Details</h4>
            <p>{specifications.otherDetails.careInstructions}</p>

            <h4>Dimensions</h4>
            <ul>
                {Object.entries(specifications.dimensions).map(([key, value]) => (
                    <li key={key}>
                        <strong>{key.replace(/([A-Z])/g, " $1")}: </strong>
                        {value}
                    </li>
                ))}
            </ul>

            <h4>Warranty</h4>
            <ul>
                {Object.entries(specifications.warranty).map(([key, value]) => (
                    <li key={key}>
                        <strong>{key.replace(/([A-Z])/g, " $1")}: </strong>
                        {value}
                    </li>
                ))}
            </ul>

            <h4>Installation & Demo</h4>
            <p>{specifications.installationAndDemo.installationAndDemoDetails}</p>
        </div>
    );
}

export default Specifications